import React from 'react';
import { ToolInstance } from '@/types';

interface ToolSelectorProps {
  tools: ToolInstance[];
  onRemoveTool: (index: number) => void;
  onEditTool: (index: number) => void;
}

export function ToolSelector({ tools, onRemoveTool, onEditTool }: ToolSelectorProps) {
  if (tools.length === 0) {
    return (
      <div className="border border-gray-200 rounded-md p-6 text-center bg-gray-50">
        <p className="text-gray-500 italic">No tools configured. Click "Add Tool" to get started.</p>
      </div>
    );
  }

  return (
    <div className="border border-gray-200 rounded-md divide-y divide-gray-200">
      {tools.map((tool, index) => (
        <div key={index} className="p-4 bg-white flex justify-between items-start">
          <div className="flex-1">
            <h4 className="font-semibold text-gray-900">{tool.name}</h4>
            {Object.keys(tool.parameters).length > 0 && (
              <div className="mt-2">
                <p className="text-sm text-gray-600 mb-1">Parameters:</p>
                <div className="flex flex-wrap gap-1">
                  {Object.entries(tool.parameters).map(([key, value]) => (
                    <span
                      key={key}
                      className="inline-flex items-center px-2 py-1 rounded-md text-xs font-medium bg-gray-100 text-gray-800"
                    >
                      <span className="font-mono">{key}</span>:
                      <span className="ml-1">{String(value)}</span>
                    </span>
                  ))}
                </div>
              </div>
            )}
          </div>
          <div className="flex space-x-2 ml-4">
            <button
              onClick={() => onEditTool(index)}
              className="text-blue-600 hover:text-blue-700 text-sm font-medium"
            >
              Edit
            </button>
            <button
              onClick={() => onRemoveTool(index)}
              className="text-red-600 hover:text-red-700 text-sm font-medium"
            >
              Remove
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}